
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/danail-hadjiatanasov-joining",
      function () {
        return require("private-next-pages/blog/danail-hadjiatanasov-joining.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/danail-hadjiatanasov-joining"])
      });
    }
  